<!--
 * @Author: Q in 
 * @Date: 2026-02-27 09:56:45
 * @LastEditors: Q in 
 * @LastEditTime: 2026-03-06 17:31:32
 * @FilePath: /bf_web/src/App.vue
 * @Description: 根组件
-->
<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',

    components: {},
};
</script>

<style scoped lang='scss'>
#app {
    line-height: 1.5;
}
</style>
